import React, { useEffect, useRef } from "react";
import { func, instanceOf } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Selector from "pages/_components/fields/formik/Selector";
import Button from "pages/_components/Button";
import { actions as cedipActions } from "reducers/cedip";
import { states, stateActivePendient } from "util/cedip";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";

const FORM_ID = "cedips";

const FilterForm = ({ customValues, closeSidebar }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { cedipFilters } = useSelector((state) => state.cedip);
    const statesOptions = i18n.formatOption(states, "cedips.states");

    const initialValues = {
        status: "TODOS",
        number: "",
        emitted: "",
        receiver: "",
        ...customValues,
    };

    const isDisabledSelectStatus = cedipFilters.tabSelected !== "ALL";

    useEffect(() => {
        const requestFilters = {
            createdFrom: initialValues.createdRange[0],
            createdTo: initialValues.createdRange[1],
            expiredFrom: initialValues.expiredRange[0],
            expiredTo: initialValues.expiredRange[1],
            status: initialValues.status,
            ...cedipFilters,
        };
        dispatch(cedipActions.setCedipFilters(requestFilters));
    }, []);

    useEffect(() => {
        if (!formRef.current) {
            return;
        }

        const filters = Object.entries(cedipFilters);
        filters.forEach((item) => {
            if (item[0] === "createdFrom") {
                formRef.current.setFieldValue("createdRange[0]", item[1]);
            }
            if (item[0] === "createdTo") {
                formRef.current.setFieldValue("createdRange[1]", item[1]);
            }
            if (item[0] === "expiredFrom") {
                formRef.current.setFieldValue("expiredFrom[0]", item[1]);
            }
            if (item[0] === "expiredTo") {
                formRef.current.setFieldValue("expiredTo[1]", item[1]);
            }
            if (item[0] === "tabSelected" && item[1] !== "ALL") {
                formRef.current.setFieldValue("status", stateActivePendient);
            }
            formRef.current.setFieldValue(item[0], item[1]);
        });
    }, [cedipFilters]);

    const handleSubmit = (values) => {
        const requestFilters = {
            ...cedipFilters,
            createdFrom: values.createdRange[0],
            createdTo: values.createdRange[1],
            expiredFrom: values.expiredRange[0],
            expiredTo: values.expiredRange[1],
            status: values.status,
        };
        dispatch(cedipActions.setCedipFilters(requestFilters));
        dispatch(cedipActions.filterCedipList(requestFilters));
        closeSidebar((state) => !state);
    };

    const handleReset = (setFieldValue) => {
        setFieldValue("createdRange", [null, null]);
        setFieldValue("expiredRange", [null, null]);
        setFieldValue("status", "TODOS");
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} ref={formRef}>
            {({ setFieldValue }) => (
                <Form>
                    <Row>
                        <Col xs={12} md={6}>
                            <Field
                                component={DateRangeField}
                                hidePlaceholder
                                idForm={FORM_ID}
                                minDate={getLimitDate(configUtils.getInteger("date.range.piker.days.cedip.min", -90))}
                                maxDate={getLimitDate(configUtils.getInteger("date.range.piker.days.cedip.max", 0))}
                                name="createdRange"
                                dateFormat="dd/MM/yyyy"
                                selectsRange
                                showMonthYearDropdown
                                scrollableMonthYearDropdown
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <Field
                                component={DateRangeField}
                                hidePlaceholder
                                idForm={FORM_ID}
                                minDate={getLimitDate(-3650)}
                                maxDate={getLimitDate(3650)}
                                name="expiredRange"
                                dateFormat="dd/MM/yyyy"
                                selectsRange
                                showMonthYearDropdown
                                scrollableMonthYearDropdown
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <Field
                                idForm={FORM_ID}
                                name="status"
                                component={Selector}
                                options={statesOptions}
                                disabled={isDisabledSelectStatus}
                                placeholder={i18n.get("accounts.create.choose")}
                            />
                        </Col>
                        <Col xs={12} md={6} />
                    </Row>
                    <Row className="form-actions">
                        <Col xs={12} md={6}>
                            <Button
                                className="btn-outline"
                                label="cedips.clean.filters"
                                onClick={() => handleReset(setFieldValue)}
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <Button type="submit" className="btn-primary" label="cedips.filtering" />
                        </Col>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};

FilterForm.propTypes = {
    customValues: instanceOf(Object).isRequired,
    closeSidebar: func.isRequired,
};

export default FilterForm;
